import { useEffect } from "react";
import {
  registerApiErrorToast,
  unregisterApiErrorToast,
} from "@/src/api/apiErrorToast";
import { useToast } from "@/components/providers/ToastProvider";

export function ApiErrorToastBridge() {
  const { showToast } = useToast();

  useEffect(() => {
    registerApiErrorToast((message) => showToast(message, "error"));
    return () => unregisterApiErrorToast();
  }, [showToast]);

  return null;
}
